// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ZWo7","requiredAsterisk":"Info_requiredAsterisk__2U1kV"};